module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAoCAYAAAD6xArmAAAA30lEQVRIS7XXuQ0CMRAF0HFAQ5abICQkJKMeWiCiGtdAsGUwRkbsSqv1MacLeLIsa/78AE4nWLkppXMp5VE9RLybwDHGSwjhBQCn/0XfariBVntRwR30AwBXMdxDEfGWc36K4Bla34INU1A2TEVZMAclw1yUBEvQKSxFh7AG7cJatAlboAfYCt3BlugGW6M/2AP1havucettbFrju3lsiR8GvRXeTBALvBtNWnyYeRp8GqZSfApL/zkJluBkmIuzYA7Ohqm4CKbgYniEq9bYtWK4LN4DXF8VVtyl3LSa1xfxwS2sDwlpuwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon_v2/return_black@2x.png
// module id = n2yo
// module chunks = 1